import TickIcon from "@/assets/colorable/tick.svg?react";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const CheckBox: FC<{
  isChecked?: boolean;
  onChange?: (newValue: boolean) => void;
  disabled?: boolean;
  className?: string;
  tickIconClassName?: string;
}> = ({isChecked = false, onChange, disabled = false, className, tickIconClassName}) => {
  return (
    <button
      onClick={e => {
        if (disabled || !onChange) return;

        e.preventDefault();
        e.stopPropagation();
        onChange(!isChecked);
      }}
      className={clsxm(
        "border-primary-light-solid flex size-5 items-center justify-center rounded-md border shadow-xs transition-all duration-150",
        isChecked ? "bg-primary-dark-solid" : "bg-white",
        disabled
          ? `border-neutral-grey-light cursor-not-allowed ${
              isChecked ? "bg-neutral-grey-dark" : "bg-neutral-grey-lightest"
            }`
          : "",
        className,
      )}>
      {isChecked && <TickIcon className={clsxm("size-2.5 shrink-0 text-white", tickIconClassName)} />}
    </button>
  );
};

export default CheckBox;
